import React, { useState } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Form,
  FormGroup,
  Label,
  Col,
} from "reactstrap";
import { Colxx, Separator } from "components/common/CustomBootstrap";
import { toast } from "react-toastify";

import { useToken } from "auth/useToken";
import axios from "axiosClient";

const TransferModal = (props) => {
  const { toggle, candidate } = props;

  const [comment, setComment] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useToken();

  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comment.trim()) {
      toast.error("Transfer details cannot be empty.");
      return;
    }
    setLoading(true);

    axios
      .post(
        `/api/transfer-request/${candidate._id}`,
        { comment },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((result) => {
        setLoading(false);
        if (result.status === 200) {
          setErrorMessage("");
          setSuccess(true);
          toast.success("Transfer request sent successfully");
        } else {
          toast.error("Something went wrong.");
        }
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(err.response?.data?.message || "Something went wrong");
        toast.error("Something went wrong.");
      });
  };

  return (
    <div>
      {!loading && (
        <Row className="text-left">
          <Colxx xxs="12" className="mb-4">
            <Card className="mb-4">
              <CardBody>
                <div className="mb-2 text-center">
                  <h1>Transfer Request</h1>
                  <br />
                  <h1>for {candidate.Candidate}</h1>
                </div>
                <Separator className="mb-5" />
                <Form>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>Transfer Details</Label>
                        <Input
                          type="textarea"
                          name="comment"
                          value={comment}
                          placeholder="Please specify the preferred region and test date to transfer e.g. Tashkent - 22/04/2025"
                          onChange={(e) => setComment(e.target.value)}
                          rows="4"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
                <div>
                  <Button
                    color="light"
                    className="top-right-button"
                    onClick={toggle}
                  >
                    Close
                  </Button>

                  <Button
                    color={success ? "success" : "primary"}
                    className="top-right-button ml-2"
                    onClick={handleSubmit}
                    disabled={success || loading}
                  >
                    {success ? "Done" : loading ? "Sending..." : "Send"}
                  </Button>
                </div>
                {errorMessage && (
                  <div className="text-danger mt-2">{errorMessage}</div>
                )}
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      )}
    </div>
  );
};

export default TransferModal;
